import React, {Component} from 'react'
import {_getIAASpeed} from "../../../../../../services/apis/WorkerServices"
import formatShorterNumber from "../../../../../../helpers/common/formatShorterNumber"

class IAASpeed extends Component {
    state = {
        speed: 0
    }

    _refresh = null

    componentDidMount() {
        this._fetchSpeed()
        this._refresh = setInterval(() => {
            this._fetchSpeed()
        }, 10000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchSpeed = async () => {
        const {data, success} = await _getIAASpeed()

        if (success) {
            this.setState({
                speed: data
            })
        }
    }

    render() {
        const {speed} = this.state
        const speedByDay = formatShorterNumber(parseInt(speed * 24 * 60, 10))

        return (
            <div className="IAASpeed">
                <strong>Speed:</strong>
                <span className="Number"> {speed} req/min</span>
                <div>
                    <small>({speedByDay} req/day)</small>
                </div>
            </div>
        )
    }
}

export default IAASpeed



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAASpeed.js